import { useState } from "react";
import Image from "next/image";
import DisclaimerModal from "src/common/DisclaimerModal";
import FooterCopyright from "src/common/FooterCopyright";

const socialLinks = [
  {
    name: "Facebook",
    href: "https://www.facebook.com/abilliontradeanalytics",
    src: "/images/email/icon-facebook.png",
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/abilliontradeanalytics/",
    src: "/images/email/icon-instagram.png",
  },
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/showcase/abillion-trade-analytics",
    src: "/images/email/icon-linkedin.png",
  },
  {
    name: "YouTube",
    href: "https://www.youtube.com/@abillionTA/",
    src: "/images/youtube-ico.png",
    imgClassName: "dark:invert",
  },
  {
    name: "X",
    href: "https://x.com/AbillionTA",
    src: "/images/email/icon-twitter.png",
  },
];

const Footer = () => {
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  return (
    <>
      <footer className="w-full mt-auto py-2 px-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs md:text-sm text-gray-500 dark:text-gray-400 border-t border-gray-200 dark:border-gray-800">
        <FooterCopyright />
        <div className="flex items-center gap-2">
          {socialLinks.map(({ name, href, src, imgClassName }) => (
            <a
              key={name}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={name}
              className="w-8 h-8 rounded-full border border-gray-400 dark:border-gray-500 flex items-center justify-center hover:border-gray-700 dark:hover:border-gray-200 transition-colors"
            >
              <Image
                src={src}
                alt={name}
                width={16}
                height={16}
                className={`w-4 h-4 object-contain ${
                  imgClassName ?? "invert dark:invert-0"
                }`}
              />
            </a>
          ))}
        </div>
        <div className="text-center md:text-right flex items-center gap-2">
          <button
            onClick={() => setShowDisclaimer(true)}
            className="cursor-pointer hover:text-gray-700 dark:hover:text-gray-200 transition-colors"
          >
            Disclaimer
          </button>
          <span>|</span>
          <a
            href="https://www.abillionanalytics.com/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="cursor-pointer hover:text-gray-700 dark:hover:text-gray-200 transition-colors"
          >
            Privacy Policy
          </a>
          <span>|</span>
          <a
            href="https://www.abillionanalytics.com/terms-and-conditions/"
            target="_blank"
            rel="noopener noreferrer"
            className="cursor-pointer hover:text-gray-700 dark:hover:text-gray-200 transition-colors"
          >
            T&C
          </a>
        </div>
      </footer>

      <DisclaimerModal
        isOpen={showDisclaimer}
        onClose={() => setShowDisclaimer(false)}
        viewOnly={true}
      />
    </>
  );
};

export default Footer;
